import { render } from "./SecondaryNavigation.vue?vue&type=template&id=434ba279"
import script from "./SecondaryNavigation.vue?vue&type=script&lang=ts"
export * from "./SecondaryNavigation.vue?vue&type=script&lang=ts"
script.render = render

export default script